import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vui-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
